import { Select } from '@mui/material';
import styled from 'styled-components';

export const SelectStato = styled(Select)`
  fieldset {
    border-radius: 17px;
  }
`;
